import { Record, Map as ImmutableMap } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { OBJECT_PROPERTY } from 'automation-ui-flow-core/fields/PropertyValueTypes';
import * as DelayUntilDateActionMetadataKeys from 'automation-ui-action-features/actions/delay-until-date/DelayUntilDateActionMetadataKeys';
import TimeDelta from 'automation-ui-flow-core/fields/time/TimeDelta';
import PropertyDate from 'automation-ui-action-features/time/PropertyDate';
import StaticDate from 'automation-ui-action-features/time/StaticDate';
import TimeOfDay from 'automation-ui-flow-core/fields/time/TimeOfDay';
import TimeZoneStrategy from 'automation-ui-flow-core/fields/time/TimeZoneStrategy';
import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
export default class DelayUntilDateActionMetadata extends Record({
  [DelayUntilDateActionMetadataKeys.ACTION_TYPE]: ActionTypes.DELAY_UNTIL_DATE,
  [DelayUntilDateActionMetadataKeys.DATE]: null,
  [DelayUntilDateActionMetadataKeys.DELTA]: null,
  [DelayUntilDateActionMetadataKeys.TIME_OF_DAY]: null,
  [DelayUntilDateActionMetadataKeys.TIME_ZONE_STRATEGY]: null
}, 'DelayUntilDateActionMetadata') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const rawDate = propMap.get(DelayUntilDateActionMetadataKeys.DATE);
    const rawTimeOfDay = propMap.get(DelayUntilDateActionMetadataKeys.TIME_OF_DAY);
    const date = rawDate && rawDate.type === OBJECT_PROPERTY ? new PropertyDate(rawDate) : new StaticDate(rawDate);
    const delta = propMap.get(DelayUntilDateActionMetadataKeys.DELTA);
    const timeZoneStrategy = propMap.get(DelayUntilDateActionMetadataKeys.TIME_ZONE_STRATEGY);
    super(propMap.set(DelayUntilDateActionMetadataKeys.DATE, date).set(DelayUntilDateActionMetadataKeys.TIME_OF_DAY, rawTimeOfDay ? new TimeOfDay(rawTimeOfDay) : null).set(DelayUntilDateActionMetadataKeys.DELTA, new TimeDelta(delta)).set(DelayUntilDateActionMetadataKeys.TIME_ZONE_STRATEGY, timeZoneStrategy ? new TimeZoneStrategy(timeZoneStrategy) : new TimeZoneStrategy({})));
  }
  getDate() {
    return this.get(DelayUntilDateActionMetadataKeys.DATE);
  }
  setDate(date) {
    return this.set(DelayUntilDateActionMetadataKeys.DATE, date);
  }
  getTimeDelta() {
    return this.get(DelayUntilDateActionMetadataKeys.DELTA);
  }
  setDelta(delta) {
    const prevDelta = this.get(DelayUntilDateActionMetadataKeys.DELTA);
    return this.set(DelayUntilDateActionMetadataKeys.DELTA, prevDelta.setTimeUnit(ChronoUnit.MINUTES).setDelta(delta));
  }
  getTimeOfDay() {
    return this.get(DelayUntilDateActionMetadataKeys.TIME_OF_DAY);
  }
  setTimeOfDay(timeOfDay) {
    return this.set(DelayUntilDateActionMetadataKeys.TIME_OF_DAY, timeOfDay);
  }
  getTimeZoneStrategy() {
    return this.get(DelayUntilDateActionMetadataKeys.TIME_ZONE_STRATEGY);
  }
  setTimeZoneStrategy(timeZoneStrategy) {
    return this.set(DelayUntilDateActionMetadataKeys.TIME_ZONE_STRATEGY, timeZoneStrategy);
  }
}